import React, {Component} from 'react';

export class CustomDateInput extends React.Component {
    shouldComponentUpdate(nextProps){
        if(nextProps.value === this.props.value){
            return false;
        }
        return true;
    }

    render(){
        let props = this.props;
        return (
            <input type="text" className="form-control"
            onChange={props.onChange} onClick={props.onClick} value={props.value}/>
        );
    }
}
